<script lang="ts" setup>
import { inject, ref } from "vue";
import { vInputText } from "../directives/v-input-text";
import axios, { AxiosResponse } from "axios";
import { IItemData } from "../interfaces/products.interfaces";
import { SITEURL } from "@libTs/cms.globals";
import { CartService } from "../services/cart.service";

const cartSvc = inject<CartService>("cartSvc")!;
const model = ref({
    term: "",
});

const isSearching = ref(false);
const isCartPage = window.location.pathname.includes("cart");

const quickOrder = (): void => {
    if (model.value.term.length <= 0) {
        return;
    }

    const itemsRequest = {
        searchterm: model.value.term,
    };

    isSearching.value = true;

    axios
        .post<IItemData>(
            SITEURL + "actions/sapShop/products/get-quickorder",
            itemsRequest,
            {
                responseType: "json",
                headers: {
                    "Content-Type": "application/json",
                    "X-Requested-With": "XMLHttpRequest",
                },
            },
        )
        .then(
            // success
            (response) => {
                if (response.data) {
                    const data = response.data;

                    // check if in maintenance mode
                    if (data.ResponseStatus === 555) {
                        window.location.href = SITEURL;
                        return;
                    }

                    console.log(
                        "quickorder response:",
                        JSON.stringify(response.data),
                    );

                    if (
                        data.Items.length === 1 ||
                        data.Items[0].ItemCode == itemsRequest.searchterm
                    ) {
                        const item = data.Items[0];
                        cartSvc.addItemToCart(item, 1);

                        if (!isCartPage) {
                            window.location.href = SITEURL + "shop/cart";
                        }
                    } else {
                        window.location.href =
                            SITEURL + "shop?q=" + itemsRequest.searchterm;
                    }
                } else {
                    console.warn(
                        "Error while fetching items: No data received.",
                    );

                    window.location.href =
                        SITEURL + "shop?q=" + itemsRequest.searchterm;
                }
            },

            // error
            (response: AxiosResponse<any>) => {
                console.warn("Error: No response from server.");
                console.info(response);

                window.location.href =
                    SITEURL + "shop?q=" + itemsRequest.searchterm;
            },
        )
        .finally(() => {
            isSearching.value = false;
        });
};
</script>

<template>
    <div
        class="quickorder-input hide-xs hide-s"
        :class="isSearching ? 'loading-animation' : ''"
    >
        <form
            class="flex rounded-s"
            method="GET"
            @submit.prevent="quickOrder()"
        >
            <input
                class="input-text-btn btn-search__quickorder"
                type="submit"
                value=""
            />

            <div class="input-text">
                <input
                    type="text"
                    name="term"
                    v-model="model.term"
                    class="input-text-input"
                    placeholder="Quick order"
                    autocomplete="off"
                />
            </div>
        </form>
    </div>
</template>
